import Mirador from 'mirador';

// Required by mirador-annotation-editor
import 'react-quill/dist/quill.snow.css';

import annotationPlugins, {
    annotationAdapters,
} from 'mirador-annotation-editor';

import LocalStorageSearchPlugin from './LocalStorageSearchPlugin';

window.miradorActions = Mirador.actions;

const params = new URLSearchParams(
    window.location.search
);

const manifestId = params.get('manifest');

console.log(
    manifestId
        ? `Loading manifest: ${manifestId}`
        : 'Starting Mirador with no manifest'
);


/*
 * ------------------------------------------------------------
 * Annotation Import / Export
 * ------------------------------------------------------------
 */

const ANNOTATION_PREFIX = 'localStorage://?canvasId=';

/*
 * Export all locally stored annotations.
 */

function exportAnnotations() {
    const annotations = {};
    let count = 0;

    for (let i = 0; i < localStorage.length; i += 1) {
        const key = localStorage.key(i);

        if (!key || !key.startsWith(ANNOTATION_PREFIX)) {
            continue;
        }

        try {
            const value = JSON.parse(
                localStorage.getItem(key)
            );

            annotations[key] = value;

            if (value?.items && Array.isArray(value.items)) {
                count += value.items.length;
            }
        } catch (error) {
            console.warn(
                `Could not export localStorage key: ${key}`,
                error
            );
        }
    }

    if (count === 0) {
        alert('No annotations found in localStorage.');
        return;
    }

    const blob = new Blob(
        [JSON.stringify(annotations, null, 2)],
        {
            type: 'application/json',
        }
    );

    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'mirador-annotations.json';

    document.body.appendChild(link);
    link.click();
    link.remove();

    URL.revokeObjectURL(url);

    console.log(
        `Exported ${count} annotation${count === 1 ? '' : 's'}.`
    );
}

/*
 * Import locally stored annotations.
 */

async function importAnnotations(file) {
    try {
        const json = JSON.parse(
            await file.text()
        );

        let imported = 0;

        if (
            !json ||
            typeof json !== 'object' ||
            Array.isArray(json)
        ) {
            throw new Error(
                'Invalid annotation export format.'
            );
        }

        for (const [key, value] of Object.entries(json)) {
            if (!key.startsWith(ANNOTATION_PREFIX)) {
                continue;
            }

            if (
                !value ||
                typeof value !== 'object' ||
                !Array.isArray(value.items)
            ) {
                continue;
            }

            localStorage.setItem(
                key,
                JSON.stringify(value)
            );

            imported += value.items.length;
        }

        if (imported === 0) {
            throw new Error(
                'No Mirador annotations found in the imported file.'
            );
        }

        alert(
            `Imported ${imported} annotation${
                imported === 1 ? '' : 's'
            }. The viewer will reload.`
        );

        window.location.reload();

    } catch (error) {
        console.error(
            'Annotation import failed:',
            error
        );

        alert(
            `Import failed: ${
                error instanceof Error
                    ? error.message
                    : String(error)
            }`
        );
    }
}

/*
 * ------------------------------------------------------------
 * Connect HTML controls
 * ------------------------------------------------------------
 */

const exportButton =
    document.getElementById('export-annotations');

if (exportButton) {
    exportButton.addEventListener(
        'click',
        exportAnnotations
    );
}

const importButton =
    document.getElementById('import-annotations');

const annotationFile =
    document.getElementById('annotation-file');

if (importButton && annotationFile) {
    importButton.addEventListener(
        'click',
        () => annotationFile.click()
    );

    annotationFile.addEventListener(
        'change',
        async () => {
            const file =
                annotationFile.files?.[0];

            if (!file) {
                return;
            }

            await importAnnotations(file);

            annotationFile.value = '';
        }
    );
}


/*
 * ------------------------------------------------------------
 * Initial windows
 * ------------------------------------------------------------
 *
 * If a manifest was supplied, open it.
 *
 * If not, start with an empty workspace.
 */

const windows = manifestId
    ? [
        {
            manifestId,

            sideBarOpen: true,

            sideBarPanel: 'annotations',
        },
        
    ]
    : [];


/*
 * ------------------------------------------------------------
 * Mirador
 * ------------------------------------------------------------
 */

const miradorInstance = Mirador.viewer(
    {
        id: 'demo',

        /*
         * Empty when no manifest was supplied.
         */
        windows,

        /*
         * Keep the workspace controls available.
         */
        workspace: {
            type: 'mosaic',
        },

        workspaceControlPanel: {
            enabled: true,
        },

        window: {
            sideBarOpenByDefault: true,            
            crossOriginPolicy: 'Anonymous',

        },

        translations: {
            en: {
                    openCompanionWindow: 'Search annotations',
            
            },
        },
        /*
         * Annotation Editor configuration.
         */
        annotation: {

            adapter: (canvasId) =>
                new annotationAdapters.LocalStorageAdapter(
                    `localStorage://?canvasId=${canvasId}`,
                    'Anonymous User'
                ),

            allowTargetShapesStyling: true,

            /*
             * Keep MAE's built-in local-storage export
             * support enabled.
             */
            exportLocalStorageAnnotations: true,

            commentTemplates: [
                {
                    content:
                        '<h4>Comment</h4><p>Comment content</p>',
                    title: 'Template',
                },
                {
                    content:
                        '<h4>Comment2</h4><p>Comment content</p>',
                    title: 'Template 2',
                },
            ],

            debug: false,

            readonly: false,

            tagsSuggestions: [
                'Mirador',
                'Awesome',
                'Viewer',
                'IIIF',
                'Template',
            ],
        },

        theme: {
            palette: {
                primary: {
                    main: '#1967d2',
                },
            },
        },
    },

    [
        ...annotationPlugins,
        ...LocalStorageSearchPlugin,
    ]
);
// Make the Mirador instance available to the plugin.
window.miradorInstance = miradorInstance;
//console.log(
//    'MIRADOR INSTANCE:',
//    window.miradorInstance
//);

//console.log(
//    'MIRADOR STORE:',
//    window.miradorInstance?.store
//);

//console.log(
//    'MIRADOR STORE ACTIONS:',
//    window.miradorInstance?.store?.actions
//);

//console.log(
//console.log(
//    'MIRADOR STORE ACTION NAMES:',
//    Object.keys(
//        window.miradorInstance?.store?.actions || {}
//    )
//);
